export const environment = {
	production: false,	
	apiUrl: 'https://workflow-back-dev-3b2wcyrtzq-uc.a.run.app/api/',	
	googleClientID: '780202918374-up1qitql8181v320ifr4orkb2c05i31k.apps.googleusercontent.com'
};
